export const APP_NAME = "CaféGestor";
export const APP_VERSION = "2.0.0-fase6";

/** Prefixo de todas as rotas da API. */
export const API_PREFIX = "/api";

/**
 * Cabeçalho usado pelo frontend para enviar a chave de idempotência em
 * operações críticas (confirmar venda, produção, carga, acerto...).
 * A proteção completa (tabela `idempotency_keys` + restrições no banco)
 * entra na Fase 1.
 */
export const IDEMPOTENCY_HEADER = "idempotency-key";

/** Cabeçalho com a empresa ativa. A API sempre valida contra os vínculos do usuário. */
export const COMPANY_HEADER = "x-company-id";
